import DOMPurify from "dompurify"
import Markdown from "react-markdown"
import remarkGfm from "remark-gfm"

import { cn } from "../../lib/utils"

type RichTextValueProps = {
  value: string
  format: "markdown" | "html"
  className?: string
}

/** Render stored storefront copy without trusting its markup. */
export function RichTextValue({ value, format, className }: RichTextValueProps) {
  return (
    <div
      className={cn(
        "space-y-2 whitespace-normal break-words text-foreground [&_a]:text-foreground [&_a]:underline [&_code]:font-mono [&_code]:text-xs [&_h1]:text-base [&_h1]:font-semibold [&_h2]:font-semibold [&_h3]:font-semibold [&_ol]:list-decimal [&_ol]:pl-5 [&_strong]:font-semibold [&_ul]:list-disc [&_ul]:pl-5",
        className
      )}
    >
      {format === "html" ? (
        <div dangerouslySetInnerHTML={{ __html: DOMPurify.sanitize(value) }} />
      ) : (
        <Markdown remarkPlugins={[remarkGfm]}>{value}</Markdown>
      )}
    </div>
  )
}
